import { HijriPicker } from './../Directives/HijriPicker';
import { MedmalStepService } from './../Services/MedmalStepService';
import { uploadsForm } from './../Pages/MotorPortal/uploadsForm/uploadsForm';
import { travelPlansPipe } from './../Pipes/travelPlansPipe';
import { MedmalProposalForm } from './../Pages/MedmalPortal/MedmalProposalForm/MedmalProposalForm';
import { MedmalReviewConfirm } from './../Pages/MedmalPortal/MedmalReviewConfirm/MedmalReviewConfirm';
import { MedmalInsuredInfo } from './../Pages/MedmalPortal/MedmalInsuredInfo/MedmalInsuredInfo';
import { MedmalNewProposalConfirm } from './../Pages/MedmalPortal/MedmalNewProposalConfirm/MedmalNewProposalConfirm';
import { MedmalNewProposal } from './../Pages/MedmalPortal/MedmalNewProposal/MedmalNewProposal';
import { RenewalReviewConfirm } from './../Pages/MotorPortal/RenewalReviewConfirm/RenewalReviewConfirm';
import { RenewalPremiumInfo } from './../Pages/MotorPortal/RenewalPremiumInfo/RenewalPremiumInfo';
import { RenewalDriverInfo } from './../Pages/MotorPortal/RenewalDriverInfo/RenewalDriverInfo';
import { proposalListPipe } from './../Pipes/ProposalListPipe';
import { MotorproposalTrackingService } from './../Services/MotorproposalTrackingService';
import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { AppComponent } from './app.component';
import { Motor } from '../Pages/Motor/Motor';
import { Master } from '../Pages/MasterPage/Master';
import { Comprehensive } from '../Pages/Comprehensive/Comprehensive';
import { Dashboard } from '../Pages/Dashboard/Dashboard';
import { Medical } from '../Pages/Medical/Medical';
import { Register } from '../Pages/Register/Register';
import { BeforeLogin } from '../Pages/BeforeLogin/BeforeLogin';
import { Policy } from '../Pages/Policies/Policy';
import { Proposals } from '../Pages/Proposals/Proposals';
import { AddNewPolicy } from '../Pages/AddNewPolicy/AddNewPolicy';
import { Profile } from '../Pages/Profile/Profile';
import { InsuredInfo } from '../Pages/InsuredInfo/InsuredInfo';
import { NewReg } from '../Pages/NewReg/NewReg';
import { TooltipModule } from 'angular2-tooltips';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { Welcome } from '../Pages/Welcome/Welcome';
import { NewDashboard } from '../Pages/NewDashboard/NewDashboard';
import { ProposalForm } from '../Pages/ProposalForm/ProposalForm';
import { restURL } from '../Models/restURL';
import { tplCoversPipe } from '../Pipes/tplCoversPipe';
import { tplManCovers } from '../Pipes/tplManCovers';
import { NewProposal } from '../Pages/MotorPortal/NewProposal/NewProposal';
import { MotorProposalForm } from '../Pages/MotorPortal/MotorProposalForm/MotorProposalForm'
import { DriverInfo } from '../Pages/MotorPortal/DriverInfo/DriverInfo';
import { PremiumInfo } from '../Pages/MotorPortal/PremiumInfo/PremiumInfo';
import { ReviewConfirm } from '../Pages/MotorPortal/ReviewConfirm/ReviewConfirm';
import { InsuredBasicInfo } from '../Pages/MotorPortal/InsuredBasicInfo/InsuredBasicInfo';
import { motorProposalService } from '../Services/motorProposalService';
import { PayfortConfirm } from '../Pages/Payfort/PayfortConfirm/PayfortConfirm';
import { PayfortPayment } from '../Pages/Payfort/PayfortPayment/PayfortPayment';
import { PayfortStatus } from '../Pages/Payfort/PayfortStatus/PayfortStatus';
import { RenewalPolicy } from '../Pages/MotorPortal/RenewalPolicy/RenewalPolicy';
import { RenewalProposal } from '../Pages/MotorPortal/RenewalProposal/RenewalProposal';
import { RenewalBasicInfo } from '../Pages/MotorPortal/RenewalBasicInfo/RenewalBasicInfo';
import { renewalProposalService } from '../Services/renewalProposalService';
import { CustomMaxDirective } from '../Directives/custom-max-validator.directive';
import { CustomMinDirective } from '../Directives/custom-min-validator.directive';
import { OnlyNumber } from '../Directives/OnlyNumber ';
import { NumbersOnlyDirective } from '../Directives/NumbersOnlyDirective ';
import { SelectRequiredDirective } from '../Directives/select-required.directive';
import { LanguageService } from '../Services/languageService';
import { checkUrlRoutingGuard } from '../Services/checkUrlRoutingGuard';
import { TravelNewProposal } from '../Pages/TravelPortal/TraveNewProposal/TravelNewProposal';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TravelNewProposalConfirm } from '../Pages/TravelPortal/TravelNewProposalConfirm/TravelNewProposalConfirm';
import { TravelProposalForm } from '../Pages/TravelPortal/TravelProposalForm/TravelProposalForm';
import { TravelBasicInfo } from '../Pages/TravelPortal/TravelBasicInfo/TravelBasicInfo';
import { TravelReviewConfirm } from '../Pages/TravelPortal/TravelReviewConfirm/TravelReviewConfirm';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Login } from '../Pages/Login/Login';
import { VehicleDetails } from '../Pages/MotorPortal/VehicleDetails/VehicleDetails';
import { userinfo } from '../Services/userinfo';
import { MotorStepService } from '../Services/MotorStepService';
import { RenewalVehicleDetails } from '../Pages/MotorPortal/RenewalVehicleDetails/RenewalVehicleDetails';
import { authenticationService } from '../Services/authenticationService';
import { userService } from '../Services/userService';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { BootstrapModalModule } from 'ng2-bootstrap-modal';
import { ConfirmComponent } from '../Pages/ConfirmComponet/confirm.component';
import { PolicyWordings } from '../Pages/PolicyWordings/PolicyWordings';
import { compManCovers } from '../Pipes/compManCovers';
import { compCoversPipe } from '../Pipes/compCoversPipe';
import { CustomMonthDirective } from '../Directives/CustomMonthDirective';
import { PasswordReset } from '../Pages/PasswordReset/PasswordReset';
import { CompRenewalPolicy } from '../Pages/MotorPortal/CompRenewalPolicy/CompRenewalPolicy';
import { CompRenewalPremiumInfo } from '../Pages/MotorPortal/CompRenewalPremiumInfo/CompRenewalPremiumInfo';
import { CompRenewalProposal } from '../Pages/MotorPortal/CompRenewalProposal/CompRenewalProposal';
import { CompRenewalReviewConfirm } from '../Pages/MotorPortal/CompRenewalReviewConfirm/CompRenewalReviewConfirm';
import { PayfortConfirmNew } from '../Pages/PayfortNew/PayfortConfirmNew/PayfortConfirmNew';
import { PayfortPaymentNew } from '../Pages/PayfortNew/PayfortPaymentNew/PayfortPaymentNew';
import { PayfortStatusNew } from '../Pages/PayfortNew/PayfortStatusNew/PayfortStatusNew';
import { YearCustomValidation } from '../Directives/YearCustomValidation';
import { CustomDateValidation } from '../Directives/CustomDateDirective';

import { ToastModule } from 'ng2-toastr/ng2-toastr';
import { CustomNumberDirective } from '../Directives/CustomNumberDirective';
import { Motor_Cancellation } from '../Pages/MotorPortal/Motor_Cancellation/Motor_Cancellation';
import { Home } from '../Pages/Home/Home';
import { PayfortConfirmUpgrade } from '../Pages/PayfortUpgrade/PayfortConfirmUpgrade/PayfortConfirmUpgrade';
import { PayfortPaymentUpgrade } from '../Pages/PayfortUpgrade/PayfortPaymentUpgrade/PayfortPaymentUpgrade';
import { PayfortStatusUpgrade } from '../Pages/PayfortUpgrade/PayfortStatusUpgrade/PayfortStatusUpgrade';
import { Upgrade } from '../Pages/MotorPortal/Upgrade/Upgrade';
import { UpgradePremiumInfo } from '../Pages/MotorPortal/UpgradePremiumInfo/UpgradePremiumInfo';
import { DomesticInsuredInfo } from '../Pages/DomesticHelperPortal/DomesticInsuredInfo/DomesticInsuredInfo';
import { DomesticPremiumInfo } from '../Pages/DomesticHelperPortal/DomesticPremiumInfo/DomesticPremiumInfo';
import { AddSequenceNo } from '../Pages/AddSequenceNo/AddSequenceNo';
import { RenewalPolicies } from '../Pages/RenewalPolicies/RenewalPolicies';
import { AddDrivers } from '../Pages/MotorPortal/AddDrivers/AddDrivers';
import { ClaimsIntimation } from '../Pages/ClaimsIntimation/ClaimsIntimation';
import { ClaimStatus } from '../Pages/ClaimStatus/ClaimStatus';
import { EncryptionService } from '../Services/EncryptionService';
import { APIService } from '../Services/api.service';
import { EncryptionKeyService } from '../Services/EncryptionKeyService';
import { TravelCancellation } from '../Pages/TravelPortal/TravelCancellation/TravelCancellation';
import { TravelAddEndorsement } from '../Pages/TravelPortal/TravelAddEndorsement/TravelAddEndorsement';
import { Unsubscribe } from '../Pages/Unsubscribe/Unsubscribe';



export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, './assets/i18n/', '.json');
}

export function initializeApp(encryptionKeyService: EncryptionKeyService) {
  return () => encryptionKeyService.GetHomeDropDowns();
}

//Master Comprehensive Dashboard Policy Proposals AddNewPolicy Profile InsuredInfo Welcome NewDashboard
const appRoutes: Routes = [
  {
    path: 'Master', component: Master, children: [
      { path: 'MotorTPL', component: Motor },
      { path: 'ComprehensiveMotor', component: Comprehensive },
      { path: 'Medical', component: Medical },




    ]
  },
  {
    path: 'PolicyDashboard', component: Dashboard, canActivate: [authenticationService],
    children: [

      { path: 'Policy', component: Policy, canActivate: [authenticationService] },
      { path: 'Proposals', component: Proposals, canActivate: [authenticationService] },
      { path: 'AddNewPolicy', component: AddNewPolicy, canActivate: [authenticationService] },
      { path: 'Profile', component: Profile, canActivate: [authenticationService] },
      { path: 'InsuredInfo', component: InsuredInfo, canActivate: [authenticationService] },


    ]
  },

  {
    path: 'BeforeLogin', component: BeforeLogin,
    children: [
      { path: 'NewReg', component: NewReg },
      { path: 'Login', component: Login },
      { path: 'Unsubscribe', component: Unsubscribe }
      //Login

    ]
  },
  { path: 'Welcome', component: Welcome, canActivate: [authenticationService] },
  {
    path: 'NewDashboard', component: NewDashboard, canActivate: [authenticationService], children: [
      { path: 'ProposalForm', component: ProposalForm },
      { path: 'NewProposal', component: NewProposal },
      { path: 'Welcome', component: Welcome, canDeactivate: [checkUrlRoutingGuard] },
      { path: 'Policy', component: Policy, canDeactivate: [checkUrlRoutingGuard] },
      { path: 'Proposals', component: Proposals, canDeactivate: [checkUrlRoutingGuard] },
      { path: 'Profile', component: Profile },
      { path: 'PolicyWordings', component: PolicyWordings, canActivate: [authenticationService] },
      { path: 'InsuredInfo', component: InsuredInfo },
      { path: 'PayfortConfirm', component: PayfortConfirm, canDeactivate: [checkUrlRoutingGuard] },
      { path: 'PayfortPayment', component: PayfortPayment, canDeactivate: [checkUrlRoutingGuard] },
      { path: 'PaymentStatus', component: PayfortStatus },
      { path: 'RenewalPolicy', component: RenewalPolicy },
      { path: 'Motor_Cancellation', component: Motor_Cancellation },
      { path: 'RenewalPolicies', component: RenewalPolicies },
      { path: 'ClaimsIntimation', component: ClaimsIntimation, canActivate: [authenticationService] },
      { path: 'ClaimStatus', component: ClaimStatus, canActivate: [authenticationService] }, 
      { path: 'TravelCancellation', component: TravelCancellation , canActivate: [authenticationService]},
      { path: 'TravelAddEndorsement', component: TravelAddEndorsement, canActivate: [authenticationService]},


      {
        path: 'MotorProposalForm', component: MotorProposalForm, children: [
          { path: 'InsuredInfo', component: InsuredBasicInfo, canActivate: [checkUrlRoutingGuard, authenticationService], canDeactivate: [checkUrlRoutingGuard] },
          { path: 'DriverInfo', component: DriverInfo, canActivate: [checkUrlRoutingGuard, authenticationService], canDeactivate: [checkUrlRoutingGuard] },
          { path: 'PremiumInfo', component: PremiumInfo, canActivate: [checkUrlRoutingGuard, authenticationService], canDeactivate: [checkUrlRoutingGuard] },
          { path: 'ReviewConfirm', component: ReviewConfirm, canActivate: [checkUrlRoutingGuard, authenticationService], canDeactivate: [checkUrlRoutingGuard] },
          { path: 'VehicleDetails', component: VehicleDetails, canActivate: [checkUrlRoutingGuard, authenticationService], canDeactivate: [checkUrlRoutingGuard] },
          { path: 'uploads', component: uploadsForm, canActivate: [checkUrlRoutingGuard, authenticationService], canDeactivate: [checkUrlRoutingGuard] },
         // { path: 'uploads', component: uploadsForm },



        ]
      },
      {
        path: 'RenewalProposal', component: RenewalProposal, canActivate: [authenticationService], children: [
          { path: 'RenewalBasicInfo', component: RenewalBasicInfo, canActivate: [authenticationService] },
          { path: 'RenewalDriverInfo', component: RenewalDriverInfo, canActivate: [authenticationService] },
          { path: 'RenewalPremiumInfo', component: RenewalPremiumInfo, canActivate: [authenticationService] },
          { path: 'RenewalVehicleDetails', component: RenewalVehicleDetails, canActivate: [authenticationService] },
          { path: 'RenewalReviewConfirm', component: RenewalReviewConfirm, canActivate: [authenticationService] },
        ]
      },
      { path: 'TravelPolicy', component: TravelNewProposal, canActivate: [authenticationService] },
      { path: 'TravelPolicyConfirm', component: TravelNewProposalConfirm, canActivate: [authenticationService] },
      {
        path: 'TravelProposalForm', component: TravelProposalForm, canActivate: [authenticationService], children: [
          { path: 'TravelBasicInfo', component: TravelBasicInfo, canActivate: [authenticationService] },
          { path: 'TravelReviewConfirm', component: TravelReviewConfirm, canActivate: [authenticationService] }
        ]
      },
      { path: 'MedmalNewProposal', component: MedmalNewProposal, canActivate: [authenticationService] },
      { path: 'MedmalNewProposalConfirm', component: MedmalNewProposalConfirm, canActivate: [authenticationService] },
      { path: 'MedmalInsuredInfo', component: MedmalInsuredInfo, canActivate: [authenticationService] },
      { path: 'MedmalReviewConfirm', component: MedmalReviewConfirm, canActivate: [authenticationService] },
      {
        path: 'MedmalProposal', component: MedmalProposalForm, canActivate: [authenticationService], children: [
          { path: 'MedmalInsuredInfo', component: MedmalInsuredInfo, canActivate: [authenticationService] },
          { path: 'MedmalReviewConfirm', component: MedmalReviewConfirm, canActivate: [authenticationService] },
        ]
      },

      { path: 'CompRenewalPolicy', component: CompRenewalPolicy },
      {
        path: 'CompRenewalProposal', component: CompRenewalProposal, canActivate: [authenticationService], children: [
          { path: 'CompRenewalPremiumInfo', component: CompRenewalPremiumInfo, canActivate: [authenticationService] },
          { path: 'CompRenewalReviewConfirm', component: CompRenewalReviewConfirm, canActivate: [authenticationService] },

        ]
      },
      { path: 'PayfortPaymentNew/:id', component: PayfortPaymentNew, canDeactivate: [checkUrlRoutingGuard] },
      { path: 'PayfortConfirmNew', component: PayfortConfirmNew, canDeactivate: [checkUrlRoutingGuard] },
      { path: 'PayfortStatusNew', component: PayfortStatusNew },
      { path: 'Upgrade', component: Upgrade },
      { path: 'UpgradePremiumInfo', component: UpgradePremiumInfo },
      { path: 'PayfortPaymentUpgrade/:id', component: PayfortPaymentUpgrade },
      { path: 'PayfortConfirmUpgrade', component: PayfortConfirmUpgrade },
      { path: 'PayfortStatusUpgrade', component: PayfortStatusUpgrade }


    ]
  },
  // { path: 'NewReg', component: NewReg },
  { path: 'Register', component: Register },
  { path: 'PasswordReset/:id', component: PasswordReset },

  //{ path: 'Home', component: Home },
  //{ path: 'Home', component: LandingPage },
  { path: '', redirectTo: 'BeforeLogin/NewReg', pathMatch: 'full' },
  { path: '', redirectTo: 'Home', pathMatch: 'full' },
  {
    path: 'NewDashboard', component: NewDashboard, children: [
      { path: 'DomesticInsuredInfo', component: DomesticInsuredInfo },
      { path: 'DomesticPremiumInfo', component: DomesticPremiumInfo }]
  },
  {
    path: 'NewDashboard', component: NewDashboard, children: [
      { path: 'AddSeqNo', component: AddSequenceNo }]
  },
  {
    path: 'NewDashboard', component: NewDashboard, children: [
      { path: 'AddDrivers', component: AddDrivers }]
  }

];

@NgModule({
  declarations: [
    AppComponent, Master, VehicleDetails, Welcome, Login, ProposalForm, NewDashboard, Motor, NewReg, Comprehensive, Medical, Dashboard, Register, BeforeLogin, Policy, Proposals, AddNewPolicy, Profile, InsuredInfo,
    tplCoversPipe, tplManCovers, compCoversPipe, compManCovers, MotorProposalForm, InsuredBasicInfo, DriverInfo, PremiumInfo, ReviewConfirm, NewProposal, PayfortConfirm, PayfortPayment, PayfortStatus, RenewalPolicy, RenewalProposal, RenewalBasicInfo, CustomMaxDirective,
    CustomMinDirective, OnlyNumber, NumbersOnlyDirective, SelectRequiredDirective, TravelNewProposal, TravelNewProposalConfirm, TravelProposalForm, TravelBasicInfo, TravelReviewConfirm, proposalListPipe, RenewalDriverInfo, RenewalPremiumInfo, RenewalReviewConfirm,
    MedmalNewProposal, MedmalNewProposalConfirm, MedmalProposalForm, MedmalInsuredInfo, MedmalReviewConfirm, travelPlansPipe, uploadsForm, RenewalVehicleDetails, HijriPicker, ConfirmComponent, PolicyWordings, CustomMonthDirective, PasswordReset,
    CompRenewalPolicy, CompRenewalPremiumInfo, CompRenewalProposal, CompRenewalReviewConfirm, PayfortConfirmNew,
    PayfortPaymentNew, PayfortStatusNew, YearCustomValidation, CustomDateValidation, CustomNumberDirective, Motor_Cancellation, Home,
    PayfortConfirmUpgrade, PayfortPaymentUpgrade, PayfortStatusUpgrade, Upgrade, UpgradePremiumInfo, DomesticInsuredInfo,
    DomesticPremiumInfo, AddSequenceNo, RenewalPolicies,AddDrivers,ClaimsIntimation,ClaimStatus,TravelCancellation,TravelAddEndorsement,Unsubscribe
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    RouterModule.forRoot(appRoutes, { useHash: true }),
    FormsModule, NoopAnimationsModule,
    BsDatepickerModule.forRoot(),
    NgIdleKeepaliveModule.forRoot(), ToastModule.forRoot(),
    BootstrapModalModule.forRoot({ container: document.body }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })

  ],
  providers: [restURL,
    EncryptionKeyService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [EncryptionKeyService],
      multi: true,
    }, motorProposalService, renewalProposalService, LanguageService, checkUrlRoutingGuard, MotorproposalTrackingService, userinfo, MotorStepService, MedmalStepService, authenticationService, userService,
  APIService,EncryptionService],
  bootstrap: [AppComponent],
  entryComponents: [
    ConfirmComponent
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/app/app.module.ts